<template>
  <div class="row f-row justify-content-center no_nav_height">
    <div class="col col-12">
      <div class="h-100 d-flex flex-column">
        <div class="row f-row justify-content-center flex-grow-1">
          <div class="col col-9 flex-grow-1">
            <SelectStrategiesModal
              :strategiesOrdered="strategiesOrdered"
              v-show="showAllStrats"
              @eventOnUserIncludeStrat="onUserIncludeStrat"
              @eventOnUserCancelStrat="onUserCancelStrat"
            />
            <div class="row f-row h-100">
              <div
                class="col col-12"
                v-bind:class="[highlightBorder ? 'bdr-expo' : '']"
              >
                <div
                  id="carouselExampleIndicators"
                  class="carousel slide height-div"
                  data-interval="false"
                >
                  <!--https://getbootstrap.com/docs/4.0/components/carousel/-->
                  <ol class="carousel-indicators">
                    <li
                      data-target="#carouselExampleIndicators"
                      data-slide-to="0"
                      class="active"
                    ></li>
                    <li
                      data-target="#carouselExampleIndicators"
                      data-slide-to="1"
                    ></li>
                    <li
                      data-target="#carouselExampleIndicators"
                      data-slide-to="2"
                    ></li>
                  </ol>
                  <div class="carousel-inner h-100">
                    <!--========================== STEP 1 ==========================-->
                    <div class="carousel-item active h-100" id="step-1-div">
                      <div class="text-center h-100">
                        <div class="row f-row">
                          <div
                            class="chart-title-results text-center col col-12 bdr-b"
                          >
                            Step 1: Define Hedge Dates and Amounts
                          </div>
                        </div>

                        <div class="row f-row justify-content-center mt-2">
                          <div
                            class="col col-auto txt-label-primary-2 text-right"
                          >
                            Select:
                          </div>
                          <div
                            class="col col-4 text-center txt-label-primary-2"
                            style="height:100%; padding: 0;"
                          >
                            <label
                              :for="'selectTable'"
                              class="toggle__button_rt"
                              style="height: 100%"
                              :class="{ actives: selectedTabNotionalBoolean }"
                            >
                              <input
                                type="checkbox"
                                @click="onClientTabNotionalSelect"
                                :id="'selectTable'"
                                v-model="selectedTabNotionalBoolean"
                              />
                              <span
                                class="toggle__switch_rt"
                                style="min-width: 24rem!important;"
                              >
                                <div class="row f-row justify-content-center">
                                  <div
                                    class="col col-6 txt-label-primary-2 text-center"
                                    style="font-size: 0.8rem!important;"
                                  >
                                    Quick optimization
                                  </div>
                                  <div
                                    class="col col-6 txt-label-primary-2 text-center"
                                    style="font-size: 0.8rem!important;"
                                  >
                                    My portfolios
                                  </div>
                                </div>
                              </span>
                            </label>
                          </div>
                        </div>
                        <!-- ============== Date / Notional Creation ================== -->
                        <div class="row f-row justify-content-center">
                          <div class="col col-10 text-center">
                            <DateNotionalTable
                              v-if="selectedTabNotional === 0"
                              :colorTheme="colorTheme"
                              :currencySpecs="currencySpecs"
                              :frequency="frequency"
                              :frequencyOptions="frequencyOptions"
                              :getCountriesPair="getCountriesPair"
                              :initialDate="initialTableDate"
                              :nDates="nDates"
                              :notional="notional"
                              :position="position"
                              :selectedAsset="selectedAsset"
                              :selectedAssetType="selectedAssetLink"
                              :showCalculator="showCalculator"
                              :userNewHedge="userNewHedge"
                              @eventOnUserTableChange="onUserTableChange"
                              @eventOnUserFrequencySelection="
                                onUserFrequencySelection
                              "
                              @eventOnUserAssetSelection="onUserAssetSelection"
                              @eventOnUserPositionChange="onUserPositionChange"
                              @eventOnUserNotionalChange="onUserNotionalChange"
                              @eventOnUserDateChange="onUserDateChange"
                              @eventOnUserNDatesChange="onUserNDatesChange"
                              @eventUpdateNDates="updateNDates"
                            />
                            <PortfolioTable
                              v-else
                              :colorTheme="colorTheme"
                              :selectedAssetType="selectedAssetLink"
                              :companies="companies"
                              :selectedCompany="selectedCompany"
                              :portfolios="portfolios"
                              :selectedPortfolio="selectedPortfolio"
                              :currencies="assets"
                              :selectedAsset="selectedPortCurrency"
                              :pickedBucket="pickedBucket"
                              :selectedHedge="selectedHedge"
                              :selectedHedgeSignal="selectedHedgeSignal"
                              :showCalculator="showCalculator"
                              :processData="processData"
                              :showLoading="
                                showLoadingTopography ||
                                  showLoadingTopographyCalcs
                              "
                              :expoCurrency="baseCurrency.foreign"
                              :totalNewHedge="totalNewHedge"
                              :totalNewPercent="totalNewPercent"
                              :totalPercOfRequired="totalPercOfRequired"
                              @eventOnUserCompanySelection="
                                onUserCompanySelection
                              "
                              @eventOnUserPortfolioSelection="
                                onUserPortfolioSelection
                              "
                              @eventOnUserCurrencySelection="
                                onUserCurrencySelection
                              "
                              @eventOnBucketChange="onBucketChange"
                              @eventOnUserNewHedgeChange="onUserNewHedgeChange"
                              @eventOnUserTotalNewPercentChange="
                                onUserTotalNewPercentChange
                              "
                              @eventOnUserTotalPercOfRequiredChange="
                                onUserTotalPercOfRequiredChange
                              "
                              @eventOnUserChangedHedge="onUserChangedHedge"
                            />
                          </div>
                        </div>
                        <!-- ============== Date / Notional Creation End ============== -->
                      </div>
                      <div
                        class="carousel-caption d-none d-md-block mb-2 txt-carrousel-bottom"
                      >
                        Step 1: Define Hedge Dates and Amounts
                      </div>
                    </div>

                    <!--========================== STEP 2 ==========================-->
                    <div class="carousel-item height-div" id="step-2-div">
                      <div
                        class="d-flex flex-column"
                        style="width: 100%;"
                        v-bind:class="{
                          'h-100': !showCalculatorTemp,
                          showHist: showCalculatorTemp,
                        }"
                      >
                        <StrategiesDesigner
                          :baseCurrency="baseCurrency"
                          :colorTheme="colorTheme"
                          :dataSliced="dataSliced"
                          :hedgeData="hedgeData"
                          :historicalData="historicalData"
                          :minMaxYAxisRates="minMaxYAxisRates"
                          :renderCharts="renderCharts"
                          :selectedAssetLink="selectedAssetLink"
                          :showLCall="showLCall"
                          :showLFwd="showLFwd"
                          :showLoading="showLoadingValInputs"
                          :showLoadingHistCandles="showLoadingHistCandles"
                          :showLoadingSpot="showLoadingSpot"
                          :showLPut="showLPut"
                          :showSCall="showSCall"
                          :showSFwd="showSFwd"
                          :showSPut="showSPut"
                          :strategies="strategies"
                          :xRange="xRange"
                          @eventOnShow="onShow"
                        />
                      </div>
                    </div>

                    <!--========================== STEP 3 ==========================-->
                    <div class="carousel-item height-div" id="step-3-div">
                      <div
                        class="d-flex flex-column"
                        style="width: 100%;"
                        v-bind:class="{
                          'h-100': !showCalculatorTemp,
                          showHist: showCalculatorTemp,
                        }"
                      >
                        <StrategiesOptimization
                          :allSimulated="allSimulated"
                          :allValuated="allValuated"
                          :asset="currencyString"
                          :baseCurrency="baseCurrency"
                          :colorTheme="colorTheme"
                          :confidence="confidence"
                          :minMaxSim="minMaxSim"
                          :minMaxSimP="minMaxSimP"
                          :notionalTotal="notionalTotal"
                          :portfolioComposition="portfolioComposition"
                          :portfolioCost="portfolioCost"
                          :portfolioStats="portfolioStats"
                          :processData="processData"
                          :renderChartSignal="renderSimulationChartSignal"
                          :selectedPosition="selectedPosition"
                          :selectedStrategyLegs="
                            Object.entries(selectedStrategy).length > 0
                              ? selectedStrategy.numLegs
                              : 1
                          "
                          :showCalculator="showCalculator"
                          :showHedged="showHedged"
                          :showLoadingOptimizing="showLoadingOptimizing"
                          :showLoadingSimulating="showLoadingSimulating"
                          :shownStrategy="shownStrategy"
                          :showStrategy="showStrategy"
                          :showUnhedged="showUnhedged"
                          :simulations="simulations"
                          :simulationsSliced="simulationsSliced"
                          :valuating="valuating"
                          @eventOnUserValuateAll="onUserValuateAll"
                          @eventOnUserSimulate="onUserSimulate"
                          @eventOnShowSims="onShowSims"
                          @eventOnUserConfidence="onUserConfidence"
                          @eventOnUserOptimize="onUserOptimize"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- Left and right controls -->
                  <a
                    v-if="carouselPage > 0"
                    class="carousel-control-prev"
                    href="#carouselExampleIndicators"
                    role="button"
                    data-slide="prev"
                    style="width:var(--strategy-quote-width-margin); background: var(--lightbackground)"
                    @click="onClickCarouselMinus"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                      @click="onClickCarouselMinus"
                    ></span>
                    <span class="sr-only" @click="onClickCarouselMinus"
                      >Previous</span
                    >
                  </a>
                  <a
                    v-if="carouselPage < 2"
                    class="carousel-control-next"
                    href="#carouselExampleIndicators"
                    role="button"
                    data-slide="next"
                    style="width:var(--strategy-quote-width-margin); background: var(--lightbackground)"
                    @click="onClickCarouselPlus"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                      @click="onClickCarouselPlus"
                    ></span>
                    <span class="sr-only" @click="onClickCarouselPlus"
                      >Next</span
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col col-3 results-divider">
            <div class="row f-row">
              <div class="chart-title-results col col-12 bdr-b">
                <div class="row f-row">
                  <div
                    class="col col-auto txt-label-primary-2"
                    style="height: 30px!important; justify-content: left"
                  >
                    <span style="padding-right: 12px; padding-left: 5px;">
                      Strategies:
                    </span>
                  </div>
                  <div
                    class="col col-6 txt-label-primary-2"
                    v-if="carouselPage > 0"
                    style="z-index: 100000000!important;"
                  >
                    <Dropdown
                      v-model="selectedRiskProfile"
                      :options="riskProfileItems"
                      @change="onSelectedRiskProfile"
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Select a Company"
                      scrollHeight="400px"
                      :filter="true"
                    >
                      <template #value="slotProps">
                        {{ riskProfileItems[slotProps.value].name }}
                      </template>
                      <template #option="slotProps">
                        <div class="country-item">
                          <div>{{ slotProps.option.name }}</div>
                        </div>
                      </template>
                    </Dropdown>
                  </div>
                  <div
                    class="col col-cx txt-label-primary-2"
                    style="justify-content: left"
                    v-if="carouselPage > 0"
                  >
                    <span style="padding-left: 12px;">
                      <RiskImage
                        :riskProfile="selectedRiskProfile"
                        :userWidth="'30px'"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <StrategiesEditor
              :allSimulated="allSimulated"
              :allValuated="allValuated"
              :assetList="currencySpecs"
              :baseCurrency="baseCurrency"
              :carouselPage="carouselPage"
              :colorTheme="colorTheme"
              :contract="0"
              :currencies="assets"
              :excelData="excelData"
              :notionalTotal="notionalTotal"
              :portfolioPercLocked="portfolioPercLocked"
              :selectedAsset="
                selectedTabNotional === 0 ? selectedAsset : selectedPortCurrency
              "
              :selectedAssetLink="selectedAssetLink"
              :selectedStrategyLegs="
                Object.entries(selectedStrategy).length > 0
                  ? selectedStrategy.numLegs
                  : 1
              "
              :selectedTabNotional="selectedTabNotional"
              :showAllStrats="showAllStrats"
              :showCalculator="showCalculator"
              :showLoadingSpot="showLoadingSpot"
              :spot="spot"
              :strategies="strategies"
              :companyName="companyName"
              :isReadyStrategyValues="isReadyStrategyValues"
              :accumExcelData="accumExcelData"
              @eventOnUserShowAllStrats="onUserShowAllStrats"
              @eventOnUserValuate="onUserValuate"
              @eventOnUserValuateAll="onUserValuateAll"
              @eventOnUserStrategyDelete="onUserStrategyDelete"
              @eventOnUserAssetSelectionGeneral="onUserAssetSelectionGeneral"
              @eventOnUserSpotChange="onUserSpotChange"
              @eventOnUserSpotRefresh="onUserSpotRefresh"
              @eventOnUserCurrencySelection="onUserCurrencySelection"
              @eventOnUserChangeStrategy="onUserChangeStrategy"
              @eventOnUserCostChange="onUserCostChange"
              @eventOnUserWeightsChange="onUserWeightsChange"
              @eventOnPortfolioLockClick="onPortfolioLockClick"
              @eventOnPortfolioCostChange="onPortfolioCostChange"
            />
          </div>
        </div>
        <div
          class="d-flex flex-column"
          style="width: 100%;"
          v-bind:class="{
            showCalc1: showCalculator && selectedStrategy.numLegs === 1,
            showCalc2: showCalculator && selectedStrategy.numLegs === 2,
            showCalc3: showCalculator && selectedStrategy.numLegs === 3,
            showCalc: showCalculator && selectedStrategy.numLegs > 3,
            hideCalc: !showCalculator,
          }"
        >
          <div class="row f-row">
            <div class="markets-chart-title bdr-b bdr-t col col-12 d-flex">
              <span class="mr-auto">Calculator</span>
              <div
                class="sidebarHidden on-over-pointer"
                style="width: 130px!important; text-align: center; font-size: 0.8rem"
              >
                <span @click="onShowCalculator"
                  >{{ !showCalculator ? "Show" : "Hide" }} calculator:
                </span>
                <button
                  @click="onShowCalculator"
                  class="btn mr-1"
                  style="width: 12px;"
                >
                  <i class="fa fa-expand" v-if="!showCalculator"></i>
                  <i class="fa fa-compress" v-if="showCalculator"></i>
                </button>
              </div>
            </div>
          </div>
          <Calculator
            :baseCurrency="baseCurrency"
            :carouselPage="carouselPage"
            :colorTheme="colorTheme"
            :selectedStrategy="selectedStrategy"
            :showCalculator="showCalculator"
            :spot="spot"
            @eventOnShowCalculator="onShowCalculator"
            @eventOnUserValuate="onUserValuate"
            @eventOnUserCostChange="onUserCostChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Calculator from "@/components/optimizer/Calculator";
import DateNotionalTable from "@/components/optimizer/DateNotionalTable";
import Dropdown from "primevue/dropdown";
import PortfolioTable from "@/components/optimizer/PortfolioTable";
import RiskImage from "@/components/optimizer/RiskImage";
import SelectStrategiesModal from "@/components/optimizer/SelectStrategiesModal";
import StrategiesDesigner from "@/components/optimizer/StrategiesDesigner";
import StrategiesEditor from "@/components/optimizer/StrategiesEditor";
import StrategiesOptimization from "@/components/optimizer/StrategiesOptimization";
import {
  buildPortfolioSimulations,
  createSelectedHedge,
  defineStrategyProfile,
  getCountriesPair,
  getMinusCarouselPage,
  getPlusCarouselPage,
  getPortfolios,
  holidaysCorrection,
  includeStrategy,
  initializeStrategiesRProfile,
  OptimizerManager,
  portfolioStatistics,
  readyToSimulate,
  step1to2Currency,
} from "@/_core/data/Optimizer";
import {
  additionalYSpace,
  date2Str,
  formatDate_DDMMMYHMS,
  noNanNum,
  sortByKey,
} from "@/_core/_helpers/_helpers";
import { getStrategiesData } from "@/_core/data/api_calls/getStrategiesData";
import { getSpotData } from "@/_core/data/api_calls/getSpotData";
import { getCandleData } from "@/_core/data/api_calls/getCandleData";
import { optimizeHedge, updateStrategyValues } from "@/_core/data/APICalls";
import { getInitialStrategyValues } from "@/_core/data/api_calls/getInitialStrategyValues";
import { simulateStrategies } from "@/_core/data/api_calls/simulateStrategies";
import {
  frequencyOptions,
  portfolioConst,
  portfolioStatsConst,
  riskProfileItemsConst,
  strategiesOptConst,
} from "@/_core/_helpers/_parametric_tools";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { format, selectAll, sum, timeParse } from "d3";

export default {
  name: "Currency",
  components: {
    Calculator,
    DateNotionalTable,
    Dropdown,
    PortfolioTable,
    RiskImage,
    SelectStrategiesModal,
    StrategiesDesigner,
    StrategiesEditor,
    StrategiesOptimization,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    companies: { required: true, default: () => [] },
    countrySpecs: { required: true, default: () => [] },
    currencyPKs: { required: true, default: () => [] },
    currencySpecs: { required: true, default: () => [] },
    processData: { required: true },
  },
  data() {
    return {
      allCommodities: [],
      assets: null,
      budgetRate: 0,
      carouselPage: 0,
      confidence: 90,
      currencies: [],
      currencyString: "N/AN/A",
      data: [],
      dataRaw: [],
      dataSliced: [],
      excelData: [],
      accumExcelData: {},
      expandFRow: true,
      expoDataRaw: [],
      expoDateField: "date",
      faildGetHistoricalData: false,
      finalDate: new Date(),
      frequency: "M",
      frequencyOptions: frequencyOptions,
      getCountriesPair: getCountriesPair,
      hedgeData: [],
      hedgeDataRaw: [],
      hedgeDataSliced: [],
      hedgeDateField: "date",
      hedgeTemplate: [],
      highlightBorder: false,
      historicalData: [],
      historicalOHLC: { open: 0, high: 0, low: 0, close: 0 },
      initialCandleDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 1),
      ),
      initCurrencyDate: new Date(
        new Date().setMonth(new Date().getMonth() - 12),
      ),
      initialDate: new Date(new Date().setDate(new Date().getDate() + 1)),
      initialTableDate: date2Str(
        new Date(new Date().setMonth(new Date().getMonth() + 1)),
        0,
      ),
      isReadyStrategyValues: false,
      isCurrency: true,
      minMaxSim: [+Infinity, -Infinity],
      minMaxSimP: [+Infinity, -Infinity],
      minMaxYAxisHist: [+Infinity, -Infinity],
      minMaxYAxisRates: [+Infinity, -Infinity],
      nDates: 6,
      notional: 100000,
      optimizerManager: null,
      pickedBucket: "1M",
      portfolio: portfolioConst,
      portfolioCost: 0,
      portfolioNumbers: [],
      portfolioPercLocked: true,
      portfolios: [],
      portfolioStats: portfolioStatsConst,
      position: "buy",
      prevHedgeTemplate: [],
      renderCharts: 0,
      renderSimulationChartSignal: 0,
      riskProfileItems: riskProfileItemsConst,
      selectedAsset: 5,
      selectedAssetLink: 0,
      selectedCompany: 0,
      selectedHedge: [],
      selectedHedgeSignal: 0,
      selectedPortCurrency: 0,
      selectedPortfolio: 0,
      selectedRiskProfile: 0,
      selectedStrategy: {},
      selectedTabNotional: 0,
      showAllStrats: false,
      showCalculator: false,
      showCalculatorTemp: false,
      showHedged: true,
      showLCall: true,
      showLFwd: true,
      showLoadingFutExpo: false,
      showLoadingFutHedge: false,
      showLoadingHistCandles: false,
      showLoadingOptimizing: false,
      showLoadingPortCalcs: false,
      showLoadingProgram: false,
      showLoadingSimulating: false,
      showLoadingSpot: false,
      showLoadingStrategies: null,
      showLoadingTopographyCalcs: false,
      showLoadingTopographyCalcsRates: false,
      showLoadingUpdateSpot: false,
      showLoadingValInputs: false,
      showLoadingValuating: false,
      showLPut: true,
      showSCall: true,
      showSFwd: true,
      showSPut: true,
      showStrategy: true,
      showUnhedged: true,
      signal1: require("@/assets/images/signal1.svg"),
      signal2: require("@/assets/images/signal2.svg"),
      signal3: require("@/assets/images/signal3.svg"),
      signal4: require("@/assets/images/signal4.svg"),
      signal5: require("@/assets/images/signal5.svg"),
      simulations: [],
      simulationsSliced: [],
      spot: null,
      spotData: null,
      strategies: strategiesOptConst,
      strategiesList: [],
      strategiesOrdered: [],
      strategyListByPK: {},
      todayDate: timeParse("%Y-%m-%d")(date2Str(new Date(), 0)),
      totalNewHedge: 0,
      totalNewPercent: 0,
      totalPercOfRequired: 100,
      userCosts: { fwd: 0.001, volSpread: 0.0025, mu: 0.001 },
      userNewHedge: [],
      valuationDataRaw: [],
      xRange: [],
    };
  },
  created() {
    document.title = "Optimizer | Fx";
  },
  mounted() {
    let _this = this;
    this.optimizerManager = new OptimizerManager(0, this);
    try {
      let auxBool = false;
      if (
        this.$store.state.user_preferences.all.items.optimizer_choices
          .selected_company === undefined ||
        this.$store.state.user_preferences.all.items.optimizer_choices
          .selected_company == null
      ) {
        auxBool = true;
      } else if (
        this.$store.state.user_preferences.all.items.optimizer_choices
          .selected_company >
        this.companies.length - 1
      ) {
        auxBool = true;
      }
      if (auxBool) {
        this.$store.state.user_preferences.all.items.optimizer_choices.selected_company = 0;
        saveUserPreferences(this);
      } else {
        this.selectedCompany = this.$store.state.user_preferences.all.items.optimizer_choices.selected_company;
      }
    } catch (error) {
      console.error(`Error selected company ${error}`);
    }
    this.portfolios = getPortfolios(this);
    this.portfolios = sortByKey(this.portfolios, "name");
    this.assets = this.portfolios[this.selectedPortfolio].asset;
    this.assets = this.assets.sort((a, b) => +a - b);
    Object.assign(this, {
      currencyString: this.assets[this.selectedPortCurrency],
    });
    Object.assign(this, {
      selectedAsset: this.currencySpecs.findIndex(
        (d) => d.currency_name === _this.currencyString,
      ),
    });
    if (this.selectedAsset === -1) {
      Object.assign(this, { selectedAsset: 0 });
      Object.assign(this, {
        currencyString: this.currencySpecs[0].currency_name,
      });
    }
    Object.assign(this, {
      currencyNumber: this.currencySpecs.filter(
        (curr) => curr.currency_name === this.currencyString,
      )[0].pk_i_idcurrency,
    });
    this.portfolioNumbers = [];
    this.portfolioNumbers.push(this.portfolios[this.selectedPortfolio].pk);

    //==== Portfolios companies initializer =====//
    this.apiCalls();
    getStrategiesData(this, "strategiesList", "showLoadingStrategies");
    this.showLoadingSpot = true;
    getSpotData(this, "spot", "updatedAt", "showLoadingSpot").then((data) =>
      this.parseSpotData(data),
    );

    this.userNewHedge = createSelectedHedge(
      this.initialTableDate,
      this.notional,
      this.nDates,
      this.frequency,
    );
    holidaysCorrection(this);
  },
  computed: {
    baseCurrency: {
      get() {
        // Ensure currencyString is a string before attempting slice
        const currencyString = this.currencyString || "NaNNaN"; // Default to empty string if not defined
        return {
          isCurrency: true,
          rate: currencyString,
          foreign: currencyString.slice(0, 3), // Safe slice
          base: currencyString.slice(3, 6), // Safe slice
          changeBase: "N.A.",
        };
      },
      set() {
        return {
          isCurrency: true,
          rate: "",
          foreign: "",
          base: "",
          changeBase: "N.A.",
        };
      },
    },
    portfolioComposition() {
      let port = [];
      this.strategies.forEach(function(d) {
        port.push({
          perc: +d.percentage,
          name: d.name.replace("LONG ", "+").replace("SHORT ", "-"),
        });
      });
      return port;
    },
    shownStrategy() {
      let selected = { id: -1, name: null };
      this.strategies.forEach(function(d) {
        if (d.show === true) {
          selected = { id: d.id, name: d.name };
        }
      });
      return selected;
    },
    notionalTotal() {
      return sum(this.hedgeTemplate, function(d) {
        return d.notional;
      });
    },
    allValuated() {
      let bool = true;
      this.strategies.forEach(function(d) {
        if (d.calculated === false) {
          bool = false;
        }
      });
      return bool;
    },
    valuating() {
      let bool = false;
      this.strategies.forEach(function(d) {
        if (d.showLoading === true) {
          bool = true;
        }
      });
      return bool;
    },
    allSimulated() {
      let bool = true;
      this.strategies.forEach(function(d) {
        if (d.simulated === false) {
          bool = false;
        }
      });
      return bool;
    },
    selectedPosition() {
      let pos = 1;
      if (this.selectedTabNotional === 1) {
        pos = -Math.sign(
          this.dataRaw
            .map((d) => d.balance + d.cash_flow)
            .reduce((a, b) => a + b, 0),
        );
      } else {
        pos = this.position === "buy" ? 1 : -1;
      }
      return pos;
    },
    showLoadingTopography() {
      return (
        this.showLoadingFutExpo ||
        this.showLoadingFutHedge ||
        this.showLoadingBudget ||
        this.showLoadingProgram
      );
    },
    selectedTabNotionalBoolean: {
      get() {
        return this.selectedTabNotional === 1;
      },
      set() {
        return false;
      },
    },
    companyName() {
      return this.companies[this.selectedCompany].company_name;
    },
  },
  filters: {
    numberFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",")(val);
    },
    percentageFormat: function(val) {
      return format(",.1")(val / 100);
    },
  },
  watch: {
    selectedPosition() {
      if (this.selectedRiskProfile === 5) {
        defineStrategyProfile(this);
      } else {
        initializeStrategiesRProfile(this);
      }
    },
    showLoadingStrategies(val) {
      if (val === false) {
        let _this = this;
        this.strategiesOrdered = [];
        let longS = [],
          shortS = [],
          volS = [];
        this.strategyListByPK = {};
        this.strategiesList.forEach(function(d, i) {
          _this.strategyListByPK[d.pk_idcurrencystrategy] = i;
        });
        this.strategiesList.forEach(function(d) {
          if (d.undelying_position === -1) {
            longS.push(d);
          } else if (d.undelying_position === 1) {
            shortS.push(d);
          } else {
            volS.push(d);
          }
        });
        this.strategiesOrdered = { long: longS, short: shortS, vol: volS };
        initializeStrategiesRProfile(this);
      }
    },
    showLoadingTopography(val) {
      if (val === false) {
        if (this.expoDataRaw.length === 0 && this.hedgeDataRaw.length === 0) {
          this.dataSliced = [];
          this.showLoadingTopographyCalcs = false;
          this.showLoadingTopographyCalcsRates = false;
          return;
        }
        this.topographyCalculateAndFinish();
      }
    },
    showLoadingHistCandles(val) {
      this.calculateMinMaxYAxisRates(val);
      if (val === false) {
        if (this.showLoadingSpot === false) {
          this.historicalData = this.processData.includeSpotNew(
            this.historicalData,
            this.spotData,
          );
        }
      }
    },
    showLoadingUpdateSpot(val) {
      if (val === false) {
        this.showLoadingSpot = false;
        this.optimizerManager.mergeOnSpotChange(this);
        this.hedgeData = [];
        this.minMaxYAxisRates = [
          this.minMaxYAxisHist[0],
          this.minMaxYAxisHist[1],
        ];
        this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
        this.renderCharts += 1;
      }
    },
    dataSliced() {
      const val = this.showLoadingHistCandles;
      this.calculateMinMaxYAxisRates(val);
    },
  },
  methods: {
    // ========== ========== user interactions ========= ==========
    // ========== main view user interactions =========
    async onClickCarouselPlus() {
      this.carouselPage = getPlusCarouselPage();
      if (this.carouselPage === 0) {
        this.hedgeTemplate = [];
        this.hedgeData = [];
        this.minMaxYAxisRates = [
          this.minMaxYAxisHist[0],
          this.minMaxYAxisHist[1],
        ];
        this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
        this.renderCharts += 1;
      } else if (this.carouselPage === 1) {
        let _this = this;
        this["showLoadingHistCandles"] = true;
        getCandleData(this, "currency")
          .then((data) => {
            data = data.filter((d) => +d.date >= +this.initialCandleDate);
            this["historicalData"] = data;
            this["historicalOHLC"] = JSON.parse(
              JSON.stringify(data[data.length - 1]),
            );
            this["historicalOHLC"].open = +this["historicalOHLC"].open;
            this["historicalOHLC"].high = +this["historicalOHLC"].high;
            this["historicalOHLC"].low = +this["historicalOHLC"].low;
            this["historicalOHLC"].close = +this["historicalOHLC"].close;
            this["showLoadingHistCandles"] = false;
          })
          .catch(function(error) {
            _this["showLoadingHistCandles"] = false;
            _this["historicalData"] = [];
            console.error(error);
          });
        this.xRange = this.dataSliced.map((d) => d.date);
        if (
          this.hedgeTemplate.length === 0 ||
          this.prevHedgeTemplate !== this.hedgeTemplate
        ) {
          while (this.showLoadingSpot) {
            await new Promise((resolve) => setTimeout(resolve, 100));
          }
          step1to2Currency(this);
          this.optimizerManager.buildJsonStepOne();
        }
      } else if (this.carouselPage === 2) {
        this.showCalculator = false;
        this.onUserValuateAll();
        this.renderSimulationChartSignal += 1;
      }
    },
    onClickCarouselMinus() {
      this.carouselPage = getMinusCarouselPage();
      if (this.carouselPage === 0) {
        this.hedgeTemplate = [];
        this.hedgeData = [];
        this.dataSliced = [];
        this.minMaxYAxisHist = [+Infinity, -Infinity];
        this.minMaxYAxisRates = [+Infinity, -Infinity];
        this.strategies.forEach(function(d) {
          d.show = false;
          d.calculated = false;
          d.data = [];
          d.simulated = false;
          d.simulations = [];
        });
        this.selectedStrategy = {};
      } else if (this.carouselPage === 1) {
        let idx = -1;
        this.strategies.forEach(function(d, i) {
          if (d.show) {
            idx = i;
          }
        });
        if (idx > -1) {
          this.hedgeData = this.strategies[idx].data;
          this.minMaxYAxisRates = this.processData.minMax(
            this.hedgeData,
            "strike",
            "strike",
            [this.minMaxYAxisHist[0], this.minMaxYAxisHist[1]],
          );
        } else {
          this.hedgeData = [];
          this.minMaxYAxisRates = [
            this.minMaxYAxisHist[0],
            this.minMaxYAxisHist[1],
          ];
        }
        this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
        setTimeout(() => {
          this.renderCharts += 1;
        }, 1000);
      }
    },
    onShowCalculator() {
      if (this.carouselPage === 0) {
        this.showCalculator = !this.showCalculator;
      } else {
        let fieldRender =
          this.carouselPage === 1
            ? "renderCharts"
            : "renderSimulationChartSignal";
        if (this.showCalculator === false) {
          this.showCalculatorTemp = true;
          setTimeout(() => {
            this[fieldRender] += 1;
            setTimeout(() => {
              this.showCalculatorTemp = false;
              this.showCalculator = !this.showCalculator;
              setTimeout(() => {
                this[fieldRender] += 1;
              }, 1000);
            }, 100);
          }, 100);
        } else {
          this.showCalculatorTemp = false;
          this.showCalculator = !this.showCalculator;
          setTimeout(() => {
            this[fieldRender] += 1;
          }, 100);
        }
      }
    },
    onSelectedRiskProfile(event) {
      this.hedgeData = [];
      this.minMaxYAxisRates = [
        this.minMaxYAxisHist[0],
        this.minMaxYAxisHist[1],
      ];
      this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
      this.renderCharts += 1;
      this.selectedRiskProfile = event.value;
      initializeStrategiesRProfile(this);
    },
    onUserSpotChange(val) {
      this.strategies.forEach(function(d) {
        d.show = false;
        d.calculated = false;
        d.data = [];
        d.simulated = false;
        d.simulations = [];
      });
      this.selectedStrategy = {};
      this.spot = val;
      this.optimizerManager.mergeOnSpotChange(this);
      // this.hedgeData = [];
      this.minMaxYAxisRates = [
        this.minMaxYAxisHist[0],
        this.minMaxYAxisHist[1],
      ];
      this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
      this.renderCharts += 1;
    },
    onUserSpotRefresh() {
      this.strategies.forEach(function(d) {
        d.show = false;
        d.calculated = false;
        d.data = [];
        d.simulated = false;
        d.simulations = [];
      });
      this.selectedStrategy = {};
      this.showLoadingSpot = true;
      getSpotData(
        this,
        "spot",
        "updatedAt",
        "showLoadingUpdateSpot",
      ).then((data) => this.parseSpotData(data));
    },
    onClientTabNotionalSelect() {
      this.selectedTabNotional = 1 - this.selectedTabNotional;
      if (this.selectedTabNotional === 0) {
        this.currencyString = this.currencySpecs[
          this.selectedAsset
        ].currency_name;
        this.currencyNumber = this.currencySpecs[
          this.selectedAsset
        ].pk_i_idcurrency;
      } else {
        this.currencyString = this.assets[this.selectedPortCurrency];
        this.currencyNumber = this.currencySpecs.filter(
          (curr) => curr.currency_name === this.currencyString,
        )[0].pk_i_idcurrency;
      }
      this.showLoadingSpot = true;
      getSpotData(this, "spot", "updatedAt", "showLoadingSpot").then((data) =>
        this.parseSpotData(data),
      );
    },
    // ========== StrategiesOptimization.vue =========
    onUserConfidence(val) {
      this.confidence = val;
      portfolioStatistics(this);
    },
    onUserOptimize(args) {
      optimizeHedge(this, args, "showLoadingOptimizing");
    },
    // ========== StrategiesEditor.vue =========
    onUserValuateAll() {
      this.isReadyStrategyValues = false;
      let _this = this;
      let asset = "currencies";
      this.strategies.forEach(function(d) {
        d.show = false;
      });
      this.selectedStrategy = {};
      this.hedgeData = [];
      this.minMaxYAxisRates = [
        this.minMaxYAxisHist[0],
        this.minMaxYAxisHist[1],
      ];
      this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
      this.renderCharts += 1;
      let j = 0;
      let i;
      for (i = 0; i < _this.strategies.length; i++) {
        if (_this.strategies[i].calculated === false) {
          (function(idx, j) {
            setTimeout(function() {
              _this.strategies[idx].showLoading = true;
              getInitialStrategyValues(
                _this,
                _this.strategiesList[
                  _this.strategyListByPK[_this.strategies[idx].pk]
                ],
                idx,
                asset,
                _this.strategies[idx].pk,
              );
            }, 100 + 500 * j);
          })(i, j);
          j += 1;
        }
      }
      this.isReadyStrategyValues = true;
      readyToSimulate(this);
    },
    onUserCostChange(args) {
      let idx = args["idx"];
      this.strategies[idx] = args["strategy"];
      this.strategies[idx].showLoading = true;
      updateStrategyValues(
        this,
        this.strategiesList[this.strategyListByPK[this.strategies[idx].pk]],
        idx,
        args["cost"],
        args["isStrip"],
        args["editedLeg"],
        args["editedIsStrip"],
        args["editedCurrAve"],
        args["editedLegStripChanged"],
        "currencies",
      );
    },
    async onUserValuate(idx) {
      this.isReadyStrategyValues = false;
      if (this.strategies[idx].calculated === false && this.carouselPage > 0) {
        if (this.showCalculator === true) {
          this.showCalculatorTemp = true;
          setTimeout(() => {
            this.hedgeData = [];
            this.renderCharts += 1;
          }, 100);
        }
        this.strategies[idx].calculated = false;
        this.strategies[idx].simulated = false;
        this.strategies[idx].showLoading = true;
        this.strategies.forEach(function(d) {
          d.show = false;
        });
        this.strategies[idx].show = true;
        this.selectedStrategy = this.strategies[idx];
        if (this.showCalculator === true) {
          setTimeout(() => {
            this.renderCharts += 1;
          }, 100);
        }
        this.showCalculatorTemp = false;
      }
      let asset = "currencies";
      await getInitialStrategyValues(
        this,
        this.strategiesList[this.strategyListByPK[this.strategies[idx].pk]],
        idx,
        asset,
        this.strategies[idx].pk,
      );

      this.isReadyStrategyValues = true;
    },
    onUserWeightsChange(percentageById) {
      buildPortfolioSimulations(this, percentageById);
    },
    onPortfolioLockClick(val) {
      this.portfolioPercLocked = val;
    },
    onPortfolioCostChange(val) {
      this.portfolioCost = val;
    },
    onUserChangeStrategy(idx) {
      let fieldRender =
        this.carouselPage === 1
          ? "renderCharts"
          : "renderSimulationChartSignal";
      if (this.strategies[idx].show === true) {
        this.selectedStrategy = {};
        this.strategies[idx].show = false;
        this.hedgeData = [];
        if (
          this.carouselPage === 1 &&
          this.strategies[idx].calculated === true
        ) {
          this.minMaxYAxisRates = [
            this.minMaxYAxisHist[0],
            this.minMaxYAxisHist[1],
          ];
          this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
          this[fieldRender] += 1;
        }
      } else {
        if (
          this.strategies[idx].calculated === false &&
          this.carouselPage > 0
        ) {
          this.onUserValuate(idx);
        } else {
          this.strategies.forEach(function(d) {
            d.show = false;
          });
          this.strategies[idx].show = true;
          this.selectedStrategy = this.strategies[idx];
          if (this.carouselPage === 1) {
            if (this.showCalculator === true) {
              this.showCalculatorTemp = true;
              setTimeout(() => {
                this[fieldRender] += 1;
              }, 500);
            }
            this.hedgeData = this.strategies[idx].data;
            this.minMaxYAxisRates = this.processData.minMax(
              this.hedgeData,
              "strike",
              "strike",
              [this.minMaxYAxisHist[0], this.minMaxYAxisHist[1]],
            );
            this.minMaxYAxisRates = this.processData.minMax(
              this.hedgeData.filter(
                (d) =>
                  d.derivative_type.indexOf("OUT") > -1 ||
                  d.derivative_type.indexOf("IN") > -1,
              ),
              "barrier",
              "barrier",
              [this.minMaxYAxisRates[0], this.minMaxYAxisRates[1]],
            );
            this.minMaxYAxisRates = additionalYSpace(
              this.minMaxYAxisRates,
              0.05,
            );
            if (this.showCalculator === true) {
              setTimeout(() => {
                this.showCalculatorTemp = false;
                this[fieldRender] += 1;
              }, 1000);
            } else {
              this.showCalculatorTemp = false;
              this[fieldRender] += 1;
            }
          }
        }
      }
    },
    onUserShowAllStrats(val) {
      this.showAllStrats = val;
    },
    onUserStrategyDelete(strats) {
      this.selectedRiskProfile = 5;
      strats.forEach(function(d, i) {
        d.id = i;
        d.simulated = false;
        if (d.calculated) {
          d.data.forEach(function(dat) {
            dat.strategy_code = i;
          });
        }
      });
      this.simulations = [];
      this.simulationsSliced = [];
      this.strategies = strats;
      readyToSimulate(this);
    },
    // ========== StrategiesOptimization.vue =========
    onUserSimulate() {
      simulateStrategies(this, "simulations", "showLoadingSimulating", 0);
    },
    // ========== SelectStrategiesModal.vue =========
    onUserCancelStrat() {
      this.showAllStrats = false;
    },
    onUserIncludeStrat(item) {
      this.selectedRiskProfile = 5;
      this.strategies.forEach(function(d) {
        d.show = false;
      });
      includeStrategy(this, item, this.selectedPosition);
      this.simulations = [];
      this.simulationsSliced = [];
      this.strategies.forEach(function(d, i) {
        d.id = i;
        d.simulated = false;
        if (d.calculated) {
          d.data.forEach(function(dat) {
            dat.strategy_code = i;
          });
        }
      });
      this.selectedStrategy = this.strategies[this.strategies.length - 1];
      this.showAllStrats = false;
    },
    // ========== PortfolioTable.vue =========
    onUserCompanySelection(val) {
      this.minMaxYAxisRates = [+Infinity, -Infinity];
      this.minMaxYAxisHist = [+Infinity, -Infinity];
      this.selectedHedge.splice(0, this.selectedHedge.length);
      this.selectedCompany = val;
      this.portfolios = getPortfolios(this);
      this.portfolios = sortByKey(this.portfolios, "name");
      this.selectedPortfolio = 0;
      this.selectedPortCurrency = 0;
      this.assets = this.portfolios[this.selectedPortfolio].asset;
      this.assets = this.assets.sort((a, b) => +a - b);
      this.currencyString = this.assets[this.selectedPortCurrency];
      this.currencyNumber = this.currencySpecs.filter(
        (curr) => curr.currency_name === this.currencyString,
      )[0].pk_i_idcurrency;
      this.showLoadingSpot = true;
      getSpotData(this, "spot", "updatedAt", "showLoadingSpot").then((data) =>
        this.parseSpotData(data),
      );
      this.portfolioNumbers = [];
      this.portfolioNumbers.push(this.portfolios[this.selectedPortfolio].pk);
      this.apiCalls();
    },
    onUserPortfolioSelection(val) {
      this.minMaxYAxisRates = [+Infinity, -Infinity];
      this.minMaxYAxisHist = [+Infinity, -Infinity];
      this.selectedHedge.splice(0, this.selectedHedge.length);
      this.selectedPortfolio = val;
      this.selectedPortCurrency = 0;
      this.assets = this.portfolios[this.selectedPortfolio].asset;
      this.assets = this.assets.sort((a, b) => +a - b);
      this.currencyString = this.assets[this.selectedPortCurrency];
      this.currencyNumber = this.currencySpecs.filter(
        (curr) => curr.currency_name === this.currencyString,
      )[0].pk_i_idcurrency;
      this.showLoadingSpot = true;
      getSpotData(this, "spot", "updatedAt", "showLoadingSpot").then((data) =>
        this.parseSpotData(data),
      );
      this.portfolioNumbers = [];
      this.portfolioNumbers.push(this.portfolios[this.selectedPortfolio].pk);
      this.apiCalls();
    },
    onUserCurrencySelection(val) {
      this.minMaxYAxisRates = [+Infinity, -Infinity];
      this.minMaxYAxisHist = [+Infinity, -Infinity];
      this.selectedHedge.splice(0, this.selectedHedge.length);
      this.selectedPortCurrency = val;
      this.currencyString = this.assets[this.selectedPortCurrency];
      this.currencyNumber = this.currencySpecs.filter(
        (curr) => curr.currency_name === this.currencyString,
      )[0].pk_i_idcurrency;
      this.showLoadingSpot = true;
      getSpotData(this, "spot", "updatedAt", "showLoadingSpot").then((data) =>
        this.parseSpotData(data),
      );
      this.portfolioNumbers = [];
      this.portfolioNumbers.push(this.portfolios[this.selectedPortfolio].pk);
      this.apiCalls();
    },
    onBucketChange(bucket) {
      // this.selectedHedge.splice(0, this.selectedHedge.length);
      this.lastPickedBucket = this.pickedBucket;
      this.pickedBucket = bucket.val;
      this.objectNewHedge = bucket.newSelectedHedge;
      this.optimizerManager.processBucket(
        this.pickedBucket,
        this.lastPickedBucket,
        this.objectNewHedge,
      );
    },
    onUserNewHedgeChange(val) {
      this.totalNewHedge = val;
      this.selectedHedge.forEach(function(item) {
        item.newHedge = val;
        item.newHedgePercent = noNanNum((100 * item.newHedge) / item.expo);
        item.totalHedgePercent = noNanNum(
          (100 *
            (item.expo * (item.expo !== 0 ? item.hedge / item.expo : 0) +
              item.newHedge)) /
            item.expo,
        );
      });
      this.selectedHedgeSignal += 1;
    },
    onUserTotalNewPercentChange(val) {
      this.totalNewPercent = val;
      this.selectedHedge.forEach(function(item) {
        item.newHedgePercent = val;
        item.newHedge = noNanNum((val / 100) * item.expo);
        item.totalHedgePercent = noNanNum(
          (100 * (item.hedge + item.newHedge)) / item.expo,
        );
      });
      this.selectedHedgeSignal += 1;
    },
    onUserTotalPercOfRequiredChange(val) {
      let percentageToChange = val / 100;
      this.totalPercOfRequired = val;
      this.selectedHedge.forEach(function(item) {
        item.newHedge = Math.max(
          0,
          percentageToChange * (item.program - item.hedge),
        );
        item.newHedgePercent = noNanNum((100 * item.newHedge) / item.expo);
        item.totalHedgePercent = noNanNum(
          (100 *
            (item.expo * (item.expo !== 0 ? item.hedge / item.expo : 0) +
              item.newHedge)) /
            item.expo,
        );
      });
      this.selectedHedgeSignal += 1;
    },
    onUserChangedHedge(val) {
      this.selectedHedge = val;
    },
    onUserAssetSelectionGeneral(val) {
      if (this.selectedTabNotional === 0) {
        this.onUserAssetSelection(val);
      } else {
        this.onUserCurrencySelection(val);
      }
    },
    // ========== DateNotionalTable.vue =========
    onUserTableChange(data) {
      this.userNewHedge = data;
    },
    onUserFrequencySelection(freq) {
      this.frequency = freq;
      this.userNewHedge = createSelectedHedge(
        this.initialTableDate,
        this.notional,
        this.nDates,
        this.frequency,
      );
      holidaysCorrection(this);
    },
    async onUserAssetSelection(asset) {
      this.strategies.forEach(function(d) {
        d.show = false;
        d.calculated = false;
        d.data = [];
        d.simulated = false;
        d.simulations = [];
      });
      this.hedgeData = [];
      this.selectedAsset = asset;
      this.currencyString = this.currencySpecs[
        this.selectedAsset
      ].currency_name;
      this.currencyNumber = this.currencySpecs[
        this.selectedAsset
      ].pk_i_idcurrency;
      this.userNewHedge = createSelectedHedge(
        this.initialTableDate,
        this.notional,
        this.nDates,
        this.frequency,
      );
      holidaysCorrection(this);
      this.showLoadingSpot = true;
      getSpotData(this, "spot", "updatedAt", "showLoadingSpot").then((data) =>
        this.parseSpotData(data),
      );
      if (this.carouselPage > 0) {
        this["showLoadingHistCandles"] = true;
        this.showLoadingValInputs = true;
        getCandleData(
          this,
          "historicalData",
          "showLoadingHistCandles",
          "historicalOHLC",
          "technical_analysis_historical",
        )
          .then((data) => {
            data = data.filter((d) => +d.date >= +this.initialCandleDate);
            this["historicalData"] = data;
            this["historicalOHLC"] = JSON.parse(
              JSON.stringify(data[data.length - 1]),
            );
            this["historicalOHLC"].open = +this["historicalOHLC"].open;
            this["historicalOHLC"].high = +this["historicalOHLC"].high;
            this["historicalOHLC"].low = +this["historicalOHLC"].low;
            this["historicalOHLC"].close = +this["historicalOHLC"].close;
            this["showLoadingHistCandles"] = false;
            this.showLoadingValInputs = false;
          })
          .catch(function(error) {
            this["showLoadingHistCandles"] = false;
            this.showLoadingValInputs = false;
            this["historicalData"] = [];
            console.error(error);
          });
        this.xRange = this.dataSliced.map((d) => d.date);
        while (this.showLoadingSpot) {
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
        step1to2Currency(this);
        this.optimizerManager.buildJsonStepOne();
      }
    },
    onUserPositionChange(position) {
      this.position = position;
      if (this.selectedRiskProfile === 5) {
        defineStrategyProfile(this);
      }
    },
    onUserNotionalChange(notional) {
      this.notional = notional;
      this.userNewHedge = createSelectedHedge(
        this.initialTableDate,
        this.notional,
        this.nDates,
        this.frequency,
      );
      holidaysCorrection(this);
    },
    onUserDateChange(dat) {
      this.initialTableDate = dat;
      this.userNewHedge = createSelectedHedge(
        this.initialTableDate,
        this.notional,
        this.nDates,
        this.frequency,
      );
      holidaysCorrection(this);
    },
    onUserNDatesChange(nDate) {
      this.nDates = nDate;
      this.userNewHedge = createSelectedHedge(
        this.initialTableDate,
        this.notional,
        this.nDates,
        this.frequency,
      );
      holidaysCorrection(this);
    },
    updateNDates(nDate) {
      this.nDates = nDate;
    },
    calculateMinMaxYAxisRates(val) {
      if (val === false) {
        this.historicalData = this.processData.ohlcNest(
          this.historicalData,
          "week",
        );
        this.minMaxYAxisHist = this.processData.minMax(
          this.historicalData,
          "high",
          "low",
        );
        this.minMaxYAxisHist = this.processData.minMax(
          this.dataSliced,
          "m2m_rate",
          "m2m_rate",
          this.minMaxYAxisHist,
        );
        this.minMaxYAxisRates = [
          this.minMaxYAxisHist[0],
          this.minMaxYAxisHist[1],
        ];
        this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
        this.renderCharts += 1;
      }
    },
    // ========== helpers =========
    apiCalls() {
      // this.finalDate = new Date();
      this.optimizerManager.loadData();
    },
    //==== Complete chart data ====//
    topographyCalculateAndFinish() {
      this.finalDate = new Date();
      this.optimizerManager.setLoadData();
    },
    onShowSims(val) {
      if (val === 0) {
        this.showUnhedged = !this.showUnhedged;
      } else if (val === 1) {
        this.showHedged = !this.showHedged;
      } else if (val === 2) {
        this.showStrategy = !this.showStrategy;
      }
      this.renderSimulationChartSignal += 1;
    },
    onShow(val) {
      if (val === 5) {
        this.showLFwd = !this.showLFwd;
      } else if (val === 6) {
        this.showSFwd = !this.showSFwd;
      } else if (val === 7) {
        this.showLCall = !this.showLCall;
      } else if (val === 8) {
        this.showSCall = !this.showSCall;
      } else if (val === 9) {
        this.showLPut = !this.showLPut;
      } else if (val === 10) {
        this.showSPut = !this.showSPut;
      }
      this.minMaxYAxisRates = this.processData.minMax(
        this.hedgeData,
        "strike",
        "strike",
        [this.minMaxYAxisHist[0], this.minMaxYAxisHist[1]],
      );
      this.minMaxYAxisRates = this.processData.minMax(
        this.hedgeData.filter(
          (d) =>
            d.derivative_type.indexOf("OUT") > -1 ||
            d.derivative_type.indexOf("IN") > -1,
        ),
        "barrier",
        "barrier",
        [this.minMaxYAxisRates[0], this.minMaxYAxisRates[1]],
      );
      this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
      this.renderCharts += 1;
    },
    parseSpotData(data, loading = "showLoadingSpot") {
      data = JSON.parse(JSON.stringify(data));
      const isEndpointBack = this.faildGetHistoricalData;
      data = isEndpointBack || Array.isArray(data) ? data[0] : data;
      this["spotData"] = data;
      const observationDateTime = `${data["time"]}`;
      const dateObj = new Date(observationDateTime);
      this["updatedAt"] = "Updated at: " + formatDate_DDMMMYHMS(dateObj);

      if (isEndpointBack) {
        this["spot"] = Number(data.close);
      } else {
        this["spot"] = data.close;
      }
      this[loading] = false;
    },
  },
  beforeDestroy() {
    selectAll(".tooltip").remove();
  },
};
</script>

<style scoped>
.p-dropdown {
  background: var(--transparent);
}
.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "Quick optimization";
  font-size: 0.8rem !important;
  padding: 0 !important;
}
.actives .toggle__switch_rt::before,
.actives .toggle__switch_rt::after {
  content: "My portfolios";
}
</style>
